import { render, staticRenderFns } from "./user-type.vue?vue&type=template&id=180fbf22&scoped=true"
import script from "./user-type.vue?vue&type=script&lang=js"
export * from "./user-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180fbf22",
  null
  
)

export default component.exports